import * as React from 'react'

import { useIpLocationStore } from 'store/server-context/ip-location'
import type {
  ICommunityLocationPickerV2,
  ISpotLocationPickerV2
} from 'type/feed'
import type { ILocationV2, IPlaceV2 } from 'type/geo'

export const useLocationPickerMenuTitles = (
  pickedLocation: ISpotLocationPickerV2 | ICommunityLocationPickerV2 | null,
  data: { id: string; place?: IPlaceV2; location?: ILocationV2 }[]
) => {
  const ipLocation = useIpLocationStore(state => state.ipLocation)

  const menuTitles: { id: string; title: string }[] = React.useMemo(() => {
    const ipLocationTitle = ipLocation?.display_name || ''
    const titles = data.map(item => ({
      id: item.id,
      title:
        item.place?.location?.display_name ??
        item.location?.display_name ??
        ipLocationTitle
    }))

    if (titles.length !== 0) {
      return titles
    }

    const id = pickedLocation?.content_ids?.[0] ?? '0'
    const title = pickedLocation ? pickedLocation.display_name : ipLocationTitle
    return [{ id, title }]
  }, [data, ipLocation?.display_name, pickedLocation])

  return menuTitles
}
